import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';


export const Wrapper = styled.div<{ noPadding?: boolean }>`
  ${({ theme, noPadding }) => `
    display: flex;
    align-items: flex-end;
    width: 100%;
    direction: rtl;
    margin-top: ${noPadding ? 0 : theme.spacing(3)};
  `}
`;

export const TextFieldWrapper = styled.div<{ mode?: 'black' | 'default' }>`
  ${({ theme, mode = 'default' }) => `
    flex-grow: 1;
    width: 142px;
    position: relative;
    input {
      ${mode === 'black' ? `border-radius: ${theme.borderRadius.large};` : ''}
      ${mode === 'black' ? `padding: ${theme.spacing(2)};` : ''}
      height: ${mode === 'black' ? '48px' : '62px'};
      border: 1px solid ${theme.colors.neutrals.grey6};
      padding-bottom: ${theme.spacing(1)};
      text-align: right;
      padding-top: ${mode === 'black' ? '22px' : '30px'}; /* custom padding for this input*/
      &:hover {
        border: ${mode === 'black' ? 2 : 1}px solid ${mode === 'black' ? theme.colors.neutrals.grey1 : theme.colors.brand.main};
      }
      &:focus {
        border: ${mode === 'black' ? 2 : 1}px solid ${mode === 'black' ? theme.colors.neutrals.grey1 : theme.colors.brand.main};
      }
    }
  `}
`;

export const TextFieldLabel = styled(SmallText)<{ mode?: 'black' | 'default' }>`
  ${({ theme, mode = 'default' }) => `
    z-index: 1;
    position: absolute;
    margin: 0;
    text-transform: lowercase;
    top: ${mode === 'black' ? '4px' : '10px'};
    right: ${mode === 'black' ? '16px' : '12px'};
    color: ${mode === 'black' ? theme.colors.neutrals.grey3 : theme.colors.neutrals.grey2};
    font-size: ${mode === 'black' ? '11px' : '13px'};
  `}
`;

export const Separator = styled(Text)<{ mode?: 'black' | 'default' }>`
  ${({ theme, mode = 'default' }) => mode === 'black' ? `
    width: 24px;
    height: 24px;
    margin: 0 ${theme.spacing(0.5)};
    position: relative;
    align-self: center;
    &:after {
      content: '';
      position: absolute;
      width: 9px;
      height: 2px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: ${theme.colors.neutrals.grey1};
      border-radius: ${theme.borderRadius.small};
    }
  ` : `
    &:after {
      content: '-';
    }
    flex-shrink: 0;
    color: ${theme.colors.neutrals.grey4};
    margin: auto ${theme.spacing(1)};
  `}
`;



export const TextCells = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;


export const PriceCell = styled.div<{ toRight? : boolean }>`
  ${({ toRight }) => `
    text-align: ${toRight ? 'right' : 'left'};
  `}
`;

export const Label = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey2};
    margin-bottom: ${theme.spacing(0.25)};
  `}
`;
